import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import type { DashboardPageProps } from '../../../lib/dashboard-page';
import { AuthLayout } from '../components/auth-layout';
import { AuthLogo } from '../components/auth-logo';
import { EnterpriseRegisterForm } from '../components/enterprise-register-form';

const PAGE = 'features:auth.pages.enterprise_register_page' satisfies I18nPrefix;

export function EnterpriseRegisterPage({ handlers }: DashboardPageProps) {
  return (
    <AuthLayout>
      <div className="sm:mx-auto sm:w-full sm:max-w-lg lg:max-w-2xl">
        <AuthLogo className="h-9 w-auto lg:mb-8" />
        <div className="flex flex-wrap lg:flex-nowrap lg:justify-between">
          <div className="relative order-1 mt-8 min-w-full flex-1 rounded-lg border border-spark-border-subtle bg-spark-surface p-10 shadow-xl sm:p-14 lg:order-0 lg:mt-0 lg:min-w-0 lg:flex-auto">
            <dl>
              <div>
                <div className="mb-4 inline-flex rounded bg-linear-to-r from-indigo-500 via-purple-500 to-pink-500 px-2.5 py-1.5 font-medium text-white text-xs uppercase tracking-wider">
                  {t(`${PAGE}.badge`)}
                </div>

                <h2 className="mb-4 font-bold text-spark-text-primary text-xl sm:text-2xl">
                  <span className="bg-linear-to-r from-fuchsia-500 to-cyan-500 bg-clip-text text-spark-accent text-transparent">
                    {t(`${PAGE}.heading_highlight`)}
                  </span>{' '}
                  {t(`${PAGE}.heading`)}
                </h2>
                <p className="max-w mt-2 text-sm text-spark-text-secondary leading-6">
                  {t(`${PAGE}.description`)}
                </p>
              </div>
              <div className="mt-6">
                <EnterpriseRegisterForm handlers={handlers} />
              </div>
              <div className="absolute inset-s-0 bottom-0 hidden h-4 w-full rounded-lg rounded-t-none bg-linear-to-r from-indigo-500 via-purple-500 to-pink-500 lg:block" />
            </dl>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
